// localize the requires here
/* eslint-disable @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports */
export const brainEmoji: string = require("./🧠.svg");
export const briefcaseEmoji: string = require("./💼.svg");
export const calendarEmoji: string = require("./📅.svg");
export const clipboardEmoji: string = require("./📋.svg");
export const linkEmoji: string = require("./🔗.svg");
export const lockAndKeyEmoji: string = require("./🔐.svg");
export const handshakeEmoji: string = require("./🤝.svg");
export const informationDeskWomanEmoji: string = require("./💁‍♀️.svg");
export const pencilEmoji: string = require("./✏️.svg");
export const settingsCogEmoji: string = require("./⚙️.svg");
export const silhouetteOfTwoPeopleEmoji: string = require("./👥.svg");
export const sparkleEmoji: string = require("./❇️.svg");
export const speechBubbleEmoji: string = require("./💬.svg");
export const rocketEmoji: string = require("./🚀.svg");
export const whitePaperEmoji: string = require("./📃.svg");
